import { useEffect, useState } from 'react';

import { usePathParam } from 'react-resource-router';

import {
  getPrCycleTimeBatchApi,
  PrCycleMetrics,
} from 'src/components/pull-requests-table/cycle-time/api/requests';
import { PullRequest as PullRequestShape } from 'src/types/pull-requests-table';

export type CycleTimeMetricsMap = {
  [uuid: string]: PrCycleMetrics;
};

export const useCycleTime = (
  shouldFetch: boolean,
  pullRequests: PullRequestShape[]
): { cycleTimeMetricsMap: CycleTimeMetricsMap } => {
  const [destinationKey, setDestinationKey] = useState('');
  const [cycleTimeMetricsMap, setCycleTimeMetricsMap] =
    useState<CycleTimeMetricsMap>({});

  const [workspaceSlug] = usePathParam('workspaceSlug');
  const [repositoryOwner] = usePathParam('repositoryOwner');

  const slug = workspaceSlug || repositoryOwner;

  useEffect(() => {
    if (shouldFetch && slug) {
      const destinationUuids = Array.from(
        new Set(pullRequests.map(pr => pr.destination.repository.uuid))
      );
      const newComputedKey = destinationUuids.join();

      if (destinationKey !== newComputedKey && destinationUuids.length >= 1) {
        setDestinationKey(newComputedKey);
        setCycleTimeMetricsMap({});

        // Fetch and store the results
        getPrCycleTimeBatchApi(slug, destinationUuids)
          .then(({ repositories }) => {
            setCycleTimeMetricsMap(
              Object.entries(repositories).reduce((acc, [key, value]) => {
                const { linkedRepository } = value;
                return linkedRepository
                  ? { ...acc, [key]: linkedRepository.metrics }
                  : acc;
              }, {})
            );
          })
          .catch(() => {
            // Sweep the error, code will run normally, will simply not render stale flags
          });
      }
    }
  }, [destinationKey, pullRequests, shouldFetch, slug]);

  return { cycleTimeMetricsMap };
};
